import React from 'react'
import { PrevIcon, NextIcon } from '../SvgIcons'

import {
  PaginationContainer,
  PageDetails,
  PageButtonsContainer,
  PageButton,
  CurrentPageNumber
} from './styles'

export const Pagination = (props) => {
  const {
    currentPage,
    totalPages,
    totalItems,
    defaultPageSize,
    handleChangePage
  } = props

  const pageSize = defaultPageSize || 10

  return (
    <PaginationContainer>
      <PageDetails>
        {pageSize * (currentPage - 1) + 1}-{totalItems < pageSize * currentPage ? totalItems : pageSize * currentPage} of {totalPages}
      </PageDetails>
      <PageButtonsContainer>
        <PageButton
          disabled={currentPage === 1}
          onClick={() => handleChangePage(currentPage - 1)}
        >
          <PrevIcon />
        </PageButton>
        <CurrentPageNumber>
          <span>{currentPage}</span>
        </CurrentPageNumber>
        <PageButton
          isNext
          disabled={currentPage === totalPages}
          onClick={() => handleChangePage(currentPage + 1)}
        >
          <NextIcon />
        </PageButton>
      </PageButtonsContainer>
    </PaginationContainer>
  )
}
